const DoNotAgreeConfirmationDialog = ({ isOpen, onConfirm, onCancel, company, isPending }) => {
    if (!isOpen) return null

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 space-y-5">

                <div className="space-y-1">
                    <h2 className="text-xl font-bold text-gray-800">Are you sure?</h2>
                    <p className="text-sm text-gray-600">
                        You have selected <strong>"I DO NOT AGREE"</strong>. This will prevent you from completing the identity verification process.
                    </p>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                    <p className="text-sm text-amber-800">
                        Please contact{' '}
                        <strong>{company?.name ? `${company.name} (the "Company")` : 'the Company'}</strong>{' '}
                        Recruitment team
                        {company?.contactEmail ? (
                            <> at{' '}
                                <a
                                    href={`mailto:${company.contactEmail}`}
                                    className="underline font-medium"
                                >
                                    {company.contactEmail}
                                </a>
                            </>
                        ) : ''}{' '}
                        to proceed.
                    </p>
                </div>

                <div className="flex gap-3 pt-1">
                    <button
                        onClick={onCancel}
                        disabled={isPending}
                        className="flex-1 px-4 py-2.5 rounded-xl border border-gray-300 text-gray-700 font-medium text-sm hover:bg-gray-50 transition-all focus:outline-none disabled:opacity-50"
                    >
                        Go Back
                    </button>
                    <button
                        onClick={onConfirm}
                        disabled={isPending}
                        className="flex-1 px-4 py-2.5 rounded-xl bg-red-600 hover:bg-red-700 text-white font-semibold text-sm transition-all focus:outline-none disabled:opacity-50"
                    >
                        {isPending ? 'Submitting...' : 'Confirm, I Do Not Agree'}
                    </button>
                </div>

            </div>
        </div>
    )
}

export default DoNotAgreeConfirmationDialog
